import React from 'react'

import {
  FaBriefcase,
  FaWarehouse,
  FaUserFriends
} from 'react-icons/fa'

function About() {
  return ( <
    div className = "about-wrapper"
    id = "about" >
    <
    div className = "about-picture" >
    <
    div className = "centerLeft" >
    <
    h2 className = "about-title tablet" > Nábytek < span > Baťka < /span></h2 >
    <
    p className = "about-text tablet" > Jsme malá rodinná firma s dvacetiletou tradicí.Preferujeme osobní přístup od návrhu, přes výrobu až po montáž. < /p> < /
    div > <
    div className = "icon-grid icon-grid-desktop" >
    <
    div className = "icon-container" >
    <
    FaBriefcase className = "about-icon briefcase" / >
    <
    p className = "icon-desc" > 20
    let zkušeností < /p> < /
      div > <
      div className = "icon-container" >
      <
      FaWarehouse className = "about-icon warehouse" / >
      <
      p className = "icon-desc" > vlastní prostory < /p> < /
      div > <
      div className = "icon-container" >
      <
      FaUserFriends className = "about-icon people" / >
      <
      p className = "icon-desc" > osobní přístup < /p> < /
      div > <
      /div> < /
      div > <
      h2 className = "about-title mobile" > Nábytek < span > Baťka < /span></h2 >
      <
      p className = "about-text mobile" > Jsme malá rodinná firma s dvacetiletou tradicí.Preferujeme osobní přístup od návrhu, přes výrobu až po montáž. < /p>

      <
      div className = "icon-grid notdesktop" >
      <
      div className = "icon-container" >
      <
      FaBriefcase className = "about-icon briefcase" / >
      <
      p className = "icon-desc" > 20
    let zkušeností < /p> < /
      div > <
      div className = "icon-container" >
      <
      FaWarehouse className = "about-icon warehouse" / >
      <
      p className = "icon-desc" > vlastní prostory < /p> < /
      div > <
      div className = "icon-container" >
      <
      FaUserFriends className = "about-icon people" / >
      <
      p className = "icon-desc" > osobní přístup < /p> < /
      div > <
      /div> < /
      div >
  );
}

export default About


// WEBPACK FOOTER //
// ./src/components/About.js